<div @spinnerShow *ngIf="showSpinner" class="spinner" [ngClass]="sizeClass">
    <div class="spinner_inner" [ngClass]="color"></div>
</div>
